import React from 'react';
import { displayBodyType, displayFuel, displayTransmission } from '@/utils/attributeDisplay';

interface Props {
  year?: number;
  mileageKm?: number;
  enginePowerHp?: number;
  fuelType?: string;
  transmission?: string;
  bodyType?: string;
  engineCc?: number;
}

export const QuickSpecsV2: React.FC<Props> = ({
  year,
  mileageKm,
  enginePowerHp,
  fuelType,
  transmission,
  bodyType,
  engineCc,
}) => {
  const items = [
    {
      key: 'km',
      label: 'Kilometraj',
      value: mileageKm ? `${mileageKm.toLocaleString('ro-RO')} km` : '—',
      show: true,
    },
    {
      key: 'fuel',
      label: 'Combustibil',
      value: displayFuel(fuelType, 'ro') || '—',
      show: !!fuelType,
    },
    {
      key: 'transmission',
      label: 'Cutie de viteze',
      value: displayTransmission(transmission, 'ro') || '—',
      show: !!transmission,
    },
    {
      key: 'body',
      label: 'Tip caroserie',
      value: displayBodyType(bodyType, 'ro') || '—',
      show: !!bodyType,
    },
    {
      key: 'cc',
      label: 'Capacitate cilindrică',
      value: engineCc ? `${engineCc.toLocaleString('ro-RO')} cm³` : '—',
      show: !!engineCc,
    },
    {
      key: 'hp',
      label: 'Putere',
      value: enginePowerHp ? `${enginePowerHp} CP` : '—',
      show: !!enginePowerHp,
    },
  ].filter((i) => i.show);

  return (
    <div className="space-y-3">
      <h3 className="text-base md:text-lg font-bold text-foreground">
        Aspecte importante
      </h3>
      <dl className="divide-y divide-border border-y border-border">
        {items.map((item) => (
          <div key={item.key} className="grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)] gap-3 py-2.5 text-sm">
            <dt className="min-w-0 text-muted-foreground">{item.label}</dt>
            <dd className="min-w-0 text-right font-semibold text-foreground">{item.value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
};
